import { useConfig } from "../Config/ConfigContext";
export const useResolveParkPagePath = (slugOrId)=>{
    const { pageUrl  } = useConfig();
    return "".concat(pageUrl, "/parks/").concat(slugOrId);
};
